import { render, staticRenderFns } from "./AboutResultFile.vue?vue&type=template&id=43f33638&scoped=true"
import script from "./AboutResultFile.vue?vue&type=script&lang=ts"
export * from "./AboutResultFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f33638",
  null
  
)

export default component.exports